import script from "./ArWechat.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArWechat.vue?vue&type=script&lang=ts&setup=true"

import "./ArWechat.vue?vue&type=style&index=0&id=124ecd2e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124ecd2e"]])

export default __exports__